import getTableConversationRelation from '../utils/getTableConversationRelation';
import { mutatorAction } from 'satcheljs';

/**
 * Sets the rsvpUnitAriaDetails value for the table conversation
 * @param conversationId id of conversation
 * @param tableViewId id of tableView
 * @param rsvpUnitAriaDetails aria details value to set
 */
export const setRsvpUnitAriaDetailsForTableConversation = mutatorAction(
    'setRsvpUnitAriaDetailsForTableConversation',
    (conversationId: string, tableViewId: string, rsvpUnitAriaDetails: string) => {
        const tableConversationRelation = getTableConversationRelation(conversationId, tableViewId);
        if (!tableConversationRelation) {
            return;
        }
        tableConversationRelation.rsvpUnitAriaDetails = rsvpUnitAriaDetails;
    }
);
